<template>
  <div class="payout-settlements-form">
    <div class="row">
      <!-- <div class="col-md-12">
        <div class="field-switch-wrapper">
          <el-switch v-model="bank.payoutSettlement"></el-switch>
          <p class="field-switch-label">Your enterprise operates</p>
          <p class="field-switch-value">kopplr Merchant Banking</p>
        </div>
      </div>-->
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="bankName" name="bankName" v-model="bank.name" type="text" class="form-control" />
            <label for="bankName">Bank name</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="accountNumber" name="accountNumber" v-model="bank.accountNumber" type="text" class="form-control" />
            <label for="accountNumber">Account number</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="swift" name="swift" v-model="bank.swift" type="text" class="form-control" />
            <label for="swift">SWIFT/BIC</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="bankCode" name="bankCode" v-model="bank.bankCode" type="text" class="form-control" />
            <label for="bankCode">Bank code</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="iban" name="iban" v-model="bank.iban" type="text" class="form-control" />
            <label for="iban">IBAN</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="accountOwnerName" name="accountOwnerName" v-model="bank.accountOwnerName" type="text" class="form-control" />
            <label for="accountOwnerName">Accountowner name</label>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="streetAndNumber" name="streetAndNumber" v-model="bank.streetAndNumber" type="text" class="form-control" />
            <label for="accountOwnerName">Bank street &amp; number</label>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="zip" name="zip" v-model="bank.zip" type="text" class="form-control" />
            <label for="zip">ZIP</label>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="city" name="city" v-model="bank.city" type="text" class="form-control" />
            <label for="city">City</label>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="country" name="country" v-model="bank.country" type="text" class="form-control" />
            <label for="country">Country</label>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="state" name="state" v-model="bank.state" type="text" class="form-control" />
            <label for="state">State</label>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <el-select class="kp-select" :class="{filled: bank.shopCurrencies.length}" v-model="bank.shopCurrencies" multiple filterable clearable placeholder>
          <template #prefix>
            <label class="select-label">Shop currencies</label>
          </template>
          <el-option v-for="currency in currencies" :key="currency.value" :label="currency.label" :value="currency.value"></el-option>
        </el-select>
      </div>
      <div class="col-md-4">
        <el-select class="kp-select" :class="{filled: bank.transactionCurrencies.length}" v-model="bank.transactionCurrencies" multiple filterable clearable placeholder>
          <template #prefix>
            <label class="select-label">Transaction currencies</label>
          </template>
          <el-option v-for="currency in currencies" :key="currency.value" :label="currency.label" :value="currency.value"></el-option>
        </el-select>
      </div>
      <div class="col-md-4">
        <el-select class="kp-select" :class="{filled: bank.payoutCurrency}" v-model="bank.payoutCurrency" filterable clearable placeholder>
          <template #prefix>
            <label class="select-label">Payout currency</label>
          </template>
          <el-option v-for="currency in currencies" :key="currency.value" :label="currency.label" :value="currency.value"></el-option>
        </el-select>
      </div>
    </div>

    <div class="text-right mt-20">
      <button class="btn" @click="next()">Next</button>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'payout-settlements-form',
  computed: {
    ...mapFields({
      bank: 'bank',
      currencies: 'currencies'
    })
  },
  methods: {
    next() {
      this.$emit('next')
    }
  }
}
</script>
